<template>
  <div>
    <!-- 底部 -->
    <div
      class="footer flex flex-col"
      v-if="$route.path.slice(0, 8) != '/teacher'"
    >
      <div class="bottom-box flex-1">
        <div class="brief-introduction" v-show="$route.path == '/index'" v-if="false">
          <div class="title">友情链接</div>
          <div class="top-link flex flex-between">
            <div>国家智慧教育公共服务平台</div>
            <div>国家智慧教育</div>
            <div>友情链接</div>
            <div>国家智慧教育</div>
          </div>
          <div class="bottom-link flex flex-between">
            <div>国家智慧教育</div>
            <div>国家智慧教育公共服务平台</div>
            <div>国家智慧教育</div>
            <div>国家智慧教育公共服务平台</div>
          </div>
        </div>

        <div class="content">
          <div class="flex align-items-center flex-center">
            <div class="iconfont" style="fontsize: 18px; marginRight: 10px">
              &#xe625;
            </div>
            <div>地址：太原市小店区龙城大街102号盛锦国际B座6层</div>
          </div>
          <div class="flex align-items-center flex-center">
            <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=14010502051184"
              style="
                display: inline-block;
                text-decoration: none;
                height: 20px;
                line-height: 20px;
                color: #fff;
              "
              ><img
                src="@/assets/images/policeBadge.png"
                style="float: left"
              />晋公网安备 14010502051184号</a
            >
            <div>|</div>
            <a
              target="_blank"
              href="https://beian.miit.gov.cn/?spm=a2cmq.17630000.J_9220772140.110.6c3379fekcNwrR#/Integrated/index"
              style="
                display: inline-block;
                text-decoration: none;
                height: 20px;
                line-height: 20px;
                color: #fff;
              "
              >晋ICP备05002232号-3</a
            >
            <div>|</div>
            信息系统安全等级保护备案证明
          </div>
          <div class="flex align-items-center flex-center">
            Copyright© 2020-2022 山西华兴科软有限公司. 版权所有 未经许可
            请勿转载
          </div>
        </div>
      </div>
    </div>
    <div class="teacher-footer" v-else>
      Copyright© 2020-2022 山西华兴科软有限公司. 版权所有 未经许可 请勿转载
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.footer {
  // height: 348px;
  margin: 0 auto;
  color: #ffffff;
  clear: both;
  min-width: 1200px;
  .top-box {
    height: 178px;
    background: #1e3958;
    .content {
      width: 1200px;
      margin: 0 auto;
      margin-top: 35px;
      .left-box {
        padding-left: 170px;
        margin-right: 30px;
        ul {
          margin-right: 102px;
        }
        li {
          font-size: 12px;
          margin-bottom: 14px;
        }
        li:first-child {
          font-size: 14px;
          margin-bottom: 19px;
        }
      }
      .right-box {
        padding-right: 170px;
        > div:nth-child(1) {
          font-size: 16px;
          margin-bottom: 20px;
        }
        :nth-child(2) {
          :nth-child(1) {
            font-size: 22px;
          }
          font-size: 20px;
        }
        :nth-child(3) {
          margin-top: 15px;

          .round-bg {
            width: 34px;
            height: 34px;
            margin-left: 12px;
            line-height: 32px;
            text-align: center;
            background: #415770;
            border-radius: 50%;
          }
        }
      }
    }
  }
  .bottom-box {
    .brief-introduction {
      width: 100%;
      background: url(~@/assets/images/home/footer-background.png) no-repeat;
      background-size: 100% 100%;
      padding: 28px 0;
      box-sizing: border-box;
      border-bottom: 1px solid rgba(106, 180, 241, 0.42);
      .title {
        text-align: center;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
      }
      .top-link,
      .bottom-link {
        width: 60%;
        margin: 30px auto;
      }
      //   .bottom-link {
      //     width: 60%;
      //     margin: 0 auto;
      //   }
    }
    .content {
      width: 100%;
      margin: 0 auto;
      font-size: 12px;
      padding: 30px 0;
      background: linear-gradient(-10deg, #0959cb, #0356ca);
      > div:nth-child(2) {
        margin-top: 18px;

        div {
          margin: 0 20px;
        }

        margin-bottom: 20px;
      }

      > div:nth-child(3) {
        margin-top: 15px;
      }

      > div:nth-child(4) {
        margin-top: 14px;
      }
    }
  }
}
.teacher-footer {
  width: 100%;
  min-width: 1200px;
  height: 58px;
  background: #1a3452;
  line-height: 58px;
  text-align: center;
  font-size: 12px;
  color: #ffffff;
  margin-top: 20px;
}
</style>